export default {
  top: state => state.specs.top,
  bottom: state => state.specs.bottom,
  height: state => state.specs.height,
  specs: state => state.specs
}
